import * as React from "react";
import { IconButton, Tag, TagLabel, TagRightIcon } from "@chakra-ui/react";
import { IoCloseOutline } from "react-icons/io5";

interface TagItemProps {
  label: React.ReactNode;
  onClose(): void;
}

const TagItem: React.FC<TagItemProps> = ({ label, onClose }) => (
  <Tag backgroundColor="dark.500" color="white">
    <TagLabel>{label}</TagLabel>
    <TagRightIcon
      as={() => (
        <IconButton
          onClick={onClose}
          variant="unstyled"
          size="3xs"
          aria-label="Remove"
          icon={<IoCloseOutline />}
        />
      )}
    />
  </Tag>
);

export default TagItem;
